import sounds from 'src/lib/sounds';

/**
 * Wrapper for playing sound effects, that will try to play on either match2 sound manager or app sound manager.
 * Probably we will need to unify this at some stage, but for now they are still separate instances.
 */
export function magicLampsPlaySfx(id: string, opts?: { volume?: number }) {
  if (opts?.volume) sounds.sfx.setVolume(id, opts.volume);
  sounds.sfx.play(id);
}
